import { Injectable } from '@angular/core';
import { firstValueFrom, map, Observable } from 'rxjs';
import { ApiService } from './api.service';
import { gtag } from '@/shared/gtag';
import { RETIVUT_DEFECTS_COUNTER, RETIVUT_PLACES_COUNTER } from '@/services/api-count';
import { RetivutDefect } from '@/types/common';
import { ensureReportMedia, type ReportMediaFailure } from './ensure-report-media';
import type { MediaUploadContext } from '@mtng-reports/models';
import type { ReportPublicationTelemetry } from './report-publication-telemetry.service';

const POST_TYPE = 'reports_retivut';

@Injectable({
  providedIn: 'root',
})
export class RetivutApiService {
  constructor(
    private apiService: ApiService,
  ) {}

  /** Uploads any gallery image still missing stored media and writes the reference back. */
  ensureReportMedia(dataArr: any[], mediaUploadContext: MediaUploadContext): Promise<ReportMediaFailure | null> {
    return ensureReportMedia(dataArr, mediaUploadContext, {
      checkConnection: () => this.apiService.checkConnection(),
      upload: (dataUrl, context) => firstValueFrom(this.apiService.media(dataUrl, context)),
    });
  }

  async createReport(obj, publicationTelemetry?: ReportPublicationTelemetry) {
    gtag('event', 'create_report', {
      type: 'retivut',
    });
    return this.apiService.createReport(POST_TYPE, obj, publicationTelemetry);
  }

  loadPlaces(): Observable<any> {
    return this.apiService.loadPlaces(RETIVUT_PLACES_COUNTER);
  }

  loadDefects(): Observable<RetivutDefect[]> {
    return this.apiService.loadDefects('retivut');
  }

  loadDefectsWithCounter(): Observable<any> {
    return this.loadDefects().pipe(
      map((defects) =>
        defects
          .map((defect) => ({ ...defect, counter: RETIVUT_DEFECTS_COUNTER[defect.ID] || 0 }))
          .sort((a, b) => b.counter - a.counter)
      )
    );
  }
}
